import { render, staticRenderFns } from "./registrations-table-tool-bar.vue?vue&type=template&id=4b6ac5b8&scoped=true"
import script from "./registrations-table-tool-bar.vue?vue&type=script&lang=js"
export * from "./registrations-table-tool-bar.vue?vue&type=script&lang=js"
import style0 from "./registrations-table-tool-bar.vue?vue&type=style&index=0&id=4b6ac5b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ac5b8",
  null
  
)

export default component.exports